module.exports = __webpack_public_path__ + "img/currents.143bf4b.svg";